import { yesNoUI } from 'platform/forms-system/src/js/web-component-patterns';
import fullSchema from 'vets-json-schema/dist/21-526EZ-ALLCLAIMS-V2-schema.json';
import { WaiverTrainingPayDescription } from '../../components/additionalInformation/waiverTrainingPay';
import ConfirmationTrainingPayWaiver from '../../components/confirmationFields/ConfirmationTrainingPayWaiver';

const { servicePay } = fullSchema.properties;

export default {
  uiSchema: {
    'ui:confirmationField': ConfirmationTrainingPayWaiver,
    'ui:description': WaiverTrainingPayDescription,
    servicePay: {
      isWaivingVaBenefitsForTrainingPay: yesNoUI({
        title: 'Do you want to receive VA disability compensation?',
        tile: true,
        labels: {
          Y: 'No, I don’t want VA disability compensation for those days.',
          N: 'Yes, I want to receive VA disability compensation for those days.',
        },
        descriptions: {
          Y: 'I want to keep my training pay. I understand my VA disability compensation will be withheld for the same number of days.',
          N: 'I understand my training pay will be withheld for the same number of days.',
        },
        required: () => true,
      }),
    },
  },
  schema: {
    type: 'object',
    required: ['servicePay'],
    properties: {
      servicePay: {
        type: 'object',
        required: ['isWaivingVaBenefitsForTrainingPay'],
        properties: {
          isWaivingVaBenefitsForTrainingPay:
            servicePay.properties.isWaivingVaBenefitsForTrainingPay,
        },
      },
    },
  },
};
